import { Routes } from '@angular/router';
import { bookingsRoutingNames } from '@rx-applications/clientsite/bookings/data-access';
import { BookingsShellComponent } from './components/bookings-shell/bookings-shell.component';

export const BOOKINGS_ROUTES: Routes = [
  {
    path: '',
    redirectTo: bookingsRoutingNames.ACCOMMODATION_BOOKINGS,
    pathMatch: 'full',
  },
  {
    path: '',
    component: BookingsShellComponent,
    children: [
      {
        path: bookingsRoutingNames.ACCOMMODATION_BOOKINGS,
        loadChildren: () =>
          import('@rx-applications/clientsite/bookings/feature-view-bookings').then((m) => m.FeatureViewBookingsModule),
      },
    ],
  },
];
